import React from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Footer from '../Comman_Layout/Footer/Footer';
import { useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import Swal from 'sweetalert2';
import $ from "jquery";
import { useState } from 'react';
import { useEffect } from 'react';
// import { useNavigate } from 'react-router';
const ITServiceProviderIndividualService1 = () => {
    const navigate = useNavigate();
    let [reactNative, setReactNative] = useState('none')
    let [flutter, setFlutter] = useState('none')
    let [kotlinNative, setKotlinNative] = useState('none')
    let [swiftObjectiveC, setSwiftObjectiveC] = useState('none')
    let [corePhp, setCorePhp] = useState('none')
    let [laravel, setLaravel] = useState('none')
    let [nodeJs, setNodeJs] = useState('none')
    let [dotNet, setDotNet] = useState('none')
    let [java, setJava] = useState('none')
    let [angular, setAngular] = useState('none')
    let [python, setPython] = useState('none')
    let [htmlCssJs, setHtmlCssJs] = useState('none')
    let [react, setReact] = useState('none')
    let [angularFrontEnd, setAngularFrontEnd] = useState('none')
    let [viewJs, setViewJs] = useState('none')
    let [wordpress, setWordpress] = useState('none')
    let [shopify, setShopify] = useState('none')
    let [openCart, setOpenCart] = useState('none')
    let [drupal, setDrupal] = useState('none')
    let [gaming, setGaming] = useState('none')
    let [blockchain, setBlockchain] = useState('none')
    let [ai, setAi] = useState('none')
    let [ml, setMl] = useState('none')
    let [metaverse, setMetaverse] = useState('none')

    const initialValues = {
        // mobile_app_service: {
        //     react_native: false,
        //     flutter: false,
        //     kotlin_native: false,
        //     swift_objective_c: false,
        // },
        mobile_app_service: [],
        front_end_service: [],
        back_end_service: [],
        cms_service: [],
        other: [],
        react_native_client: '',
        react_native_link: '',
        flutter_client: '',
        flutter_link: '',
        kotlin_native_client: '',
        kotlin_native_link: '',
        swift_objective_c_client: '',
        swift_objective_c_link: '',
        core_php_client: "",
        core_php_link: "",
        laravel_client: "",
        laravel_link: "",
        node_js_client: "",
        node_js_link: "",
        dot_net_client: "",
        dot_net_link: "",
        java_client: "",
        java_link: "",
        angular_client: "",
        angular_link: "",
        python_client: "",
        python_link: "",
        html_css_js_client: "",
        html_css_js_link: "",
        react_client: "",
        react_link: "",
        angular_frontend_client: "",
        angular_frontend_link: "",
        view_js_client: "",
        view_js_link: "",
        wordpress_client: "",
        wordpress_link: "",
        shopify_client: "",
        shopify_link: "",
        open_cart_client: "",
        open_cart_link: "",
        drupal_client: "",
        drupal_link: "",
        gaming_client: "",
        gaming_link: "",
        blockchain_client: "",
        blockchain_link: "",
        ai_client: "",
        ai_link: "",
        ml_client: "",
        ml_link: "",
        metaverse_client: "",
        metaverse_link: "",
    };

    const handleShowHideREATCNATIVE = () => {
        let react_native = document.getElementById("react-native");
        //react native text box 
        if (react_native.checked) {
            setReactNative("block");
            // initialValues.mobile_app_service.react_native = true;
            // console.log(initialValues.mobile_app_service)
        } else if (!react_native.checked) {
            setReactNative("none")
            // initialValues.mobile_app_service.react_native = false;
            // console.log(initialValues.mobile_app_service)
        }
    }
    const handleShowHideFLUTTER = () => {
        let flutter = document.getElementById("flutter");
        if (flutter.checked) {
            setFlutter("block")
            // initialValues.mobile_app_service.flutter = true;
            // console.log(initialValues.mobile_app_service.flutter)
        } else if (!flutter.checked) {
            setFlutter("none")
            // initialValues.mobile_app_service.flutter = false;
            // console.log(initialValues.mobile_app_service.flutter)
        }
    }
    const handleShowHideKOTLINNATIVE = () => {
        let kotlin_native = document.getElementById("kotlin_native");
        //flutter text box 
        if (kotlin_native.checked) {
            setKotlinNative("block")
        } else {
            setKotlinNative("none")
        }
    }
    const handleShowHideSWIFTOBJETIVEC = () => {
        let swiftobjective_c = document.getElementById("swift/objectivec");
        //flutter text box 
        if (swiftobjective_c.checked) {
            setSwiftObjectiveC("block")
        } else {
            setSwiftObjectiveC("none")
        }
    }
    const handleShowHideCOREPHP = () => {
        let core_php = document.getElementById("core_php");
        //flutter text box 
        if (core_php.checked) {
            setCorePhp("block")
        } else {
            setCorePhp("none")
        }
    }
    const handleShowHideLARAVEL = () => {
        let laravel_text = document.getElementById("laravel");
        //flutter text box 
        if (laravel_text.checked) {
            setLaravel("block")
        } else {
            setLaravel("none")
        }
    }
    const handleShowHideNODEJS = () => {
        let nodejs_text = document.getElementById("node_js");
        //flutter text box 
        if (nodejs_text.checked) {
            setNodeJs("block")
        } else {
            setNodeJs("none")
        }
    }
    const handleShowHideDOTNET = () => {
        let dot_net_text = document.getElementById("dot_net");
        //flutter text box 
        if (dot_net_text.checked) {
            setDotNet("block")
        } else {
            setDotNet("none")
        }
    }
    const handleShowHideJAVA = () => {
        let java_text = document.getElementById("java");
        //flutter text box 
        if (java_text.checked) {
            setJava("block")
        } else {
            setJava("none")
        }
    }
    const handleShowHideANGULAR = () => {
        let angular_text = document.getElementById("angular");
        //flutter text box 
        if (angular_text.checked) {
            setAngular("block")
        } else {
            setAngular("none")
        }
    }
    const handleShowHidePYTHON = () => {
        let python_text = document.getElementById("python");
        //flutter text box 
        if (python_text.checked) {
            setPython("block")
        } else {
            setPython("none")
        }
    }
    const handleShowHideREACT = () => {
        let react_text = document.getElementById("react");
        //flutter text box 
        if (react_text.checked) {
            setReact("block")
        } else {
            setReact("none")
        }
    }
    const handleShowHideHTMLCSSJS = () => {
        let html_css_js_text = document.getElementById("html_css_js");
        //flutter text box 
        if (html_css_js_text.checked) {
            setHtmlCssJs("block")
        } else {
            setHtmlCssJs("none")
        }
    }
    const handleShowHideVIEWJS = () => {
        let view_js_text = document.getElementById("view_js");
        //flutter text box 
        if (view_js_text.checked) {
            setViewJs("block")
        } else {
            setViewJs("none")
        }
    }
    const handleShowHideANGULARFRONTEND = () => {
        let angular_frontend_text = document.getElementById("angular_frontend");
        //flutter text box 
        if (angular_frontend_text.checked) {
            setAngularFrontEnd("block")
        } else {
            setAngularFrontEnd("none")
        }
    }
    const handleShowHideWORDPRESS = () => {
        let wordpress_text = document.getElementById("wordpress");
        if (wordpress_text.checked) {
            setWordpress("block")
        } else {
            setWordpress("none")
        }
    }
    const handleShowHideSHOPIFY = () => {
        let shopify_text = document.getElementById("shopify");
        if (shopify_text.checked) {
            setShopify("block")
        } else {
            setShopify("none")
        }
    }
    const handleShowHideOPENCART = () => {
        let open_cart_text = document.getElementById("open_cart");
        if (open_cart_text.checked) {
            setOpenCart("block")
        } else {
            setOpenCart("none")
        }
    }
    const handleShowHideDRUPAL = () => {
        let drupal_text = document.getElementById("drupal");
        if (drupal_text.checked) {
            setDrupal("block")
        } else {
            setDrupal("none")
        }
    }
    const handleShowHideGAMING = () => {
        let gaming_text = document.getElementById("gaming");
        if (gaming_text.checked) {
            setGaming("block")
        } else {
            setGaming("none")
        }
    }
    const handleShowHideBLOCKCHAIN = () => {
        let blockchain_text = document.getElementById("blockchain");
        if (blockchain_text.checked) {
            setBlockchain("block")
        } else {
            setBlockchain("none")
        }
    }
    const handleShowHideAI = () => {
        let ai_text = document.getElementById("ai");
        if (ai_text.checked) {
            setAi("block")
        } else {
            setAi("none")
        }
    }
    const handleShowHideML = () => {
        let ml_text = document.getElementById("ml");
        if (ml_text.checked) {
            setMl("block")
        } else {
            setMl("none")
        }
    }
    const handleShowHideMETAVERSE = () => {
        let metaverse_text = document.getElementById("metaverse");
        if (metaverse_text.checked) {
            setMetaverse("block")
        } else {
            setMetaverse("none")
        }
    }
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            //Mobile App Development
            const isReactNativeClickedMobile = reactNative == "none" ? false : true;
            const isFlutterClickedMobile = flutter == "none" ? false : true;
            const isKotlinNativeClickedMobile = kotlinNative == "none" ? false : true;
            const isSwiftObjectiveCclickedMobile = swiftObjectiveC == "none" ? false : true;
            if (isReactNativeClickedMobile) {
                values.mobile_app_service.push("React Native");
            }
            if (isFlutterClickedMobile) {
                values.mobile_app_service.push("Flutter");
            }
            if (isKotlinNativeClickedMobile) {
                values.mobile_app_service.push("Kotlin Native");
            }
            if (isSwiftObjectiveCclickedMobile) {
                values.mobile_app_service.push("Swift / Objective C");
            }

            //Back end development
            const isCorePhpClickedBackEnd = corePhp == "none" ? false : true;
            const isLaravelClickedBackEnd = laravel == "none" ? false : true;
            const isNodeJSClickedBackEnd = nodeJs == "none" ? false : true;
            const isDotNetClickedBackEnd = dotNet == "none" ? false : true;
            const isJavaClickedBackEnd = java == "none" ? false : true;
            const isAngularClickedBackEnd = angular == "none" ? false : true;
            const isPythonClickedBackEnd = python == "none" ? false : true;
            if (isCorePhpClickedBackEnd) {
                values.back_end_service.push("Core PHP");
            }
            if (isLaravelClickedBackEnd) {
                values.back_end_service.push("Laravel");
            }
            if (isNodeJSClickedBackEnd) {
                values.back_end_service.push("Node JS");
            }
            if (isDotNetClickedBackEnd) {
                values.back_end_service.push("Dot Net");
            }
            if (isJavaClickedBackEnd) {
                values.back_end_service.push("Java");
            }
            if (isAngularClickedBackEnd) {
                values.back_end_service.push("Angular");
            }
            if (isPythonClickedBackEnd) {
                values.back_end_service.push("Python");
            }

            //front end development
            const isHTMLCSSJSClickedFrontEnd = htmlCssJs == "none" ? false : true;
            const isReactClickedFrontEnd = react == "none" ? false : true;
            const isAngularClickedFrontEnd = angularFrontEnd == "none" ? false : true;
            const isVueClickedFrontEnd = viewJs == "none" ? false : true;
            if (isHTMLCSSJSClickedFrontEnd) {
                values.front_end_service.push("HTML/CSS/JS");
            }
            if (isReactClickedFrontEnd) {
                values.front_end_service.push("React");
            }
            if (isAngularClickedFrontEnd) {
                values.front_end_service.push("Angular");
            }
            if (isVueClickedFrontEnd) {
                values.front_end_service.push("View Js");
            }

            //cms service

            const isShopifyClickedCMS = shopify == "none" ? false : true;
            const isWordpressClickedCMS = wordpress == "none" ? false : true;
            const isOpenCartClickedCMS = openCart == "none" ? false : true;
            const isDrupalClickedCMS = drupal == "none" ? false : true;

            if (isShopifyClickedCMS) {
                values.cms_service.push("Shopify")
            }
            if (isWordpressClickedCMS) {
                values.cms_service.push("Wordpress")
            }
            if (isOpenCartClickedCMS) {
                values.cms_service.push("Open Cart")
            }
            if (isDrupalClickedCMS) {
                values.cms_service.push("Drupal")
            }

            //other service
            const isGamingClickedOthers = gaming == "none" ? false : true;
            const isBlockChainClickedOthers = blockchain == "none" ? false : true;
            const isAIClickedOthers = ai == "none" ? false : true;
            const isMLClickedOthers = ml == "none" ? false : true;
            const isMetaVereseClickedOthers = metaverse == "none" ? false : true;

            if (isGamingClickedOthers) {
                values.other.push("Gaming")
            }
            if (isBlockChainClickedOthers) {
                values.other.push("Blockchain")
            }
            if (isAIClickedOthers) {
                values.other.push("Artificial Intelligence")
            }
            if (isMLClickedOthers) {
                values.other.push("Machine Learning")
            }
            if (isMetaVereseClickedOthers) {
                values.other.push("Metaverse")
            }
            let timerInterval;
            Swal.fire({
                title: 'Please Wait...',
                html: 'Your query is being submitted.',
                timer: 30000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    // const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                        //   b.textContent = Swal.getTimerLeft()
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }
            })

            if (!localStorage.getItem("individual_details")) {
                Swal.fire({
                    icon: 'warning',
                    showCancelButton: true,
                    showLoading: false,
                    cancelButtonText: "Okay",
                    title: 'Warning!',
                    text: 'Please fill Basic Details first.',
                })
                navigate("/it-service-provider-individual-basic-details");
            } else {
                // axios.post('https://alobhaapi.alobhatech.com/post-associate-partner', formData, config) //for files
                let id = JSON.parse(localStorage.getItem("individual_details")).id;
                // axios.post(`http://localhost:1995/add-it-sevice-provider-individual-service-details?id=${id}`, values)
                axios.post(`https://tapi.alobhatech.com/add-it-sevice-provider-individual-service-details?id=${id}`, values)
                    .then(function (response) {
                        if (response.status == 200) {
                            localStorage.removeItem("individual_details")
                            // localStorage.removeItem("company_contact_person_details")
                            localStorage.removeItem("individual_bank_details")
                            Swal.fire(
                                'Thank you for contacting us.',
                                'We will revert back to you soon.',
                                'success'
                            )
                            navigate("/it-service-provider-individual-basic-details");

                        } else if (response.status == 201) {
                            Swal.fire(
                                'Warning',
                                'This email already exists.',
                                'warning'
                            )

                        } else if (response.status == 202) {
                            Swal.fire(
                                'Warning',
                                'This Mobile No. already exists.',
                                'warning'
                            )

                        } else {
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                        }
                    })
                    .catch(function (error) {
                        console.log(`Error:`, error.response)
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Internal Server Error',
                            'error'
                        )
                    })
            }

        }
    });
    return (
        <>
            <Navbar />

            <section className="service-provider my-5">
                <div className="container">
                    {/* =============Heading================== */}
                    <div className="empanelment-service">
                        <h1>Empanelment For IT Services Provider</h1>
                    </div>
                    {/* ===============Tab Area Start=============== */}
                    <div className="form-tab-area">
                        <ul className="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                            <Link to='/it-service-provider-company-details'>
                                <li className="nav-item">
                                    <a className="nav-link" id="pills-home-tab" data-toggle="pill" role="tab" aria-controls="pills-home" aria-selected="true">Company</a>
                                </li>
                            </Link>

                            <li className="nav-item actv-li">
                                <a className="nav-link active" id="pills-profile-tab" data-toggle="pill" role="tab" aria-controls="pills-profile" aria-selected="false">Individual</a>
                            </li>
                        </ul>

                        <div className="stepper-step mt-5">
                            <ul className="form-stepper form-stepper-horizontal text-center mx-auto pl-0">

                                <li className="form-stepper-completed text-center form-stepper-list" step="1">
                                    <Link className="mx-2" to="/it-service-provider-individual-basic-details">
                                        <span className="form-stepper-circle">
                                            <span>1</span>
                                        </span>
                                        <div className="label">Basic Details</div>
                                    </Link>
                                </li>
                                <li className="form-stepper-completed text-center form-stepper-list" step="2">
                                    <Link className="mx-2" to="/it-service-provider-individual-bank-details">
                                        <span className="form-stepper-circle text-muted">
                                            <span>2</span>
                                        </span>
                                        <div className="label text-muted">Bank Details</div>
                                    </Link>
                                </li>
                                <li className="form-stepper-active text-center form-stepper-list" step="3">
                                    <Link className="mx-2">
                                        <span className="form-stepper-circle text-muted">
                                            <span>3</span>
                                        </span>
                                        <div className="label text-muted">Service Details</div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                            {/* ===============Company Tab Area Start=============== */}
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div className="custm-form">
                                    <form id='multistepsform' onSubmit={formik.handleSubmit} >
                                        {/* -----------Services Offered Details------------ */}

                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Services Offered Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label>Mobile App Development<span></span></label>
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="mobile_app_service" value='React Native' id="react-native" onChange={handleShowHideREATCNATIVE} />
                                                    <label htmlFor="react-native" style={{ color: "black", fontWeight: "400" }}>React Native </label>
                                                    <input type="text" className='my-1 mx-1' name="react_native_client" id="react_native_client" style={{ display: reactNative }} placeholder='Relevant Clients (React Native)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.react_native_client} />
                                                    <input type="text" className='my-1 mx-1' name="react_native_link" id="react_native_link" style={{ display: reactNative }} placeholder='Relevant Links (React Native)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.react_native_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" id="flutter" name="mobile_app_service" value='Flutter' onChange={handleShowHideFLUTTER} />
                                                    <label htmlFor="flutter" style={{ color: "black", fontWeight: "400" }}>Flutter </label>
                                                    <input type="text" className='my-1 mx-1' name="flutter_client" id="flutter_client" style={{ display: flutter }} placeholder='Relevant Clients (Flutter)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.flutter_client} />
                                                    <input type="text" className='my-1 mx-1' name="flutter_link" id="flutter_link" style={{ display: flutter }} placeholder='Relevant Links (Flutter)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.flutter_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="mobile_app_service" value='Kotlin Native' id='kotlin_native' onChange={handleShowHideKOTLINNATIVE} />
                                                    <label htmlFor="kotlin_native" style={{ color: "black", fontWeight: "400" }}>Kotlin Native </label>
                                                    <input type="text" className='my-1 mx-1' name="kotlin_native_client" id="kotlin_native_client" style={{ display: kotlinNative }} placeholder='Relevant Clients (Kotlin Native)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.kotlin_native_client} />
                                                    <input type="text" className='my-1 mx-1' name="kotlin_native_link" id="kotlin_native_link" style={{ display: kotlinNative }} placeholder='Relevant Links (Kotlin Native)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.kotlin_native_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="mobile_app_service" value='Swift / Objective C' id='swift/objectivec' onChange={handleShowHideSWIFTOBJETIVEC} />
                                                    <label htmlFor="swift/objectivec" style={{ color: "black", fontWeight: "400" }}>Swift / Objective C </label>
                                                    <input type="text" className='my-1 mx-1' name="swift_objective_c_client" id="swift_objective_c_client" style={{ display: swiftObjectiveC }} placeholder='Relevant Clients (Swift/Objective C)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.swift_objective_c_client} />
                                                    <input type="text" className='my-1 mx-1' name="swift_objective_c_link" id="swift_objective_c_link" style={{ display: swiftObjectiveC }} placeholder='Relevant Links (Swift/Objective C)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.swift_objective_c_link} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>Back End Development<span></span></label>
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Core PHP' id="core_php" onChange={handleShowHideCOREPHP} />
                                                    <label htmlFor="core_php" style={{ color: "black", fontWeight: "400" }}>Core PHP </label>
                                                    <input type="text" className='my-1 mx-1' name="core_php_client" id="core_php_client" style={{ display: corePhp }} placeholder='Relevant Clients (Core PHP)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.core_php_client} />
                                                    <input type="text" className='my-1 mx-1' name="core_php_link" id="core_php_link" style={{ display: corePhp }} placeholder='Relevant Links (Core PHP)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.core_php_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" id="laravel" name="backend_service" value='Laravel' onChange={handleShowHideLARAVEL} />
                                                    <label htmlFor="laravel" style={{ color: "black", fontWeight: "400" }}>Laravel </label>
                                                    <input type="text" className='my-1 mx-1' name="laravel_client" id="laravel_client" style={{ display: laravel }} placeholder='Relevant Clients (Laravel)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.laravel_client} />
                                                    <input type="text" className='my-1 mx-1' name="laravel_link" id="laravel_link" style={{ display: laravel }} placeholder='Relevant Links (Laravel)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.laravel_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Node JS' id='node_js' onChange={handleShowHideNODEJS} />
                                                    <label htmlFor="node_js" style={{ color: "black", fontWeight: "400" }}>Node JS </label>
                                                    <input type="text" className='my-1 mx-1' name="node_js_client" id="node_js_client" style={{ display: nodeJs }} placeholder='Relevant Clients (Node JS)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.node_js_client} />
                                                    <input type="text" className='my-1 mx-1' name="node_js_link" id="node_js_link" style={{ display: nodeJs }} placeholder='Relevant Links (Node JS)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.node_js_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Dot Net' id='dot_net' onChange={handleShowHideDOTNET} />
                                                    <label htmlFor="dot_net" style={{ color: "black", fontWeight: "400" }}>Dot Net </label>
                                                    <input type="text" className='my-1 mx-1' name="dot_net_client" id="dot_net_client" style={{ display: dotNet }} placeholder='Relevant Clients (Dot Net)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.dot_net_client} />
                                                    <input type="text" className='my-1 mx-1' name="dot_net_link" id="dot_net_link" style={{ display: dotNet }} placeholder='Relevant Links (Dot Net)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.dot_net_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Java' id='java' onChange={handleShowHideJAVA} />
                                                    <label htmlFor="java" style={{ color: "black", fontWeight: "400" }}>Java </label>
                                                    <input type="text" className='my-1 mx-1' name="java_client" id="java_client" style={{ display: java }} placeholder='Relevant Clients (Java)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.java_client} />
                                                    <input type="text" className='my-1 mx-1' name="java_link" id="java_link" style={{ display: java }} placeholder='Relevant Links (Java)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.java_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Angular' id='angular' onChange={handleShowHideANGULAR} />
                                                    <label htmlFor="angular" style={{ color: "black", fontWeight: "400" }}>Angular </label>
                                                    <input type="text" className='my-1 mx-1' name="angular_client" id="angular_client" style={{ display: angular }} placeholder='Relevant Clients (Angular)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.angular_client} />
                                                    <input type="text" className='my-1 mx-1' name="angular_link" id="angular_link" style={{ display: angular }} placeholder='Relevant Links (Angular)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.angular_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="backend_service" value='Python' id='python' onChange={handleShowHidePYTHON} />
                                                    <label htmlFor="python" style={{ color: "black", fontWeight: "400" }}>Python </label>
                                                    <input type="text" className='my-1 mx-1' name="python_client" id="python_client" style={{ display: python }} placeholder='Relevant Clients (Python)' onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.python_client} />
                                                    <input type="text" className='my-1 mx-1' name="python_link" id="python_link" style={{ display: python }} placeholder='Relevant Links (Python)' onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.python_link} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label>Front End Development<span></span></label>
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="frontend_service" value='HTML/CSS/JS' id="html_css_js" onChange={handleShowHideHTMLCSSJS} />
                                                    <label htmlFor="html_css_js" style={{ color: "black", fontWeight: "400" }}>HTML/CSS/JS </label>
                                                    <input type="text" className='my-1 mx-1' name="html_css_js_client" id="html_css_js_client" style={{ display: htmlCssJs }} placeholder='Relevant Clients (HTML/CSS/JS)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.html_css_js_client} />
                                                    <input type="text" className='my-1 mx-1' name="html_css_js_link" id="html_css_js_link" style={{ display: htmlCssJs }} placeholder='Relevant Links (HTML/CSS/JS)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.html_css_js_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" id="react" name="frontend_service" value='React' onChange={handleShowHideREACT} />
                                                    <label htmlFor="react" style={{ color: "black", fontWeight: "400" }}>React </label>
                                                    <input type="text" className='my-1 mx-1' name="react_client" id="react_client" style={{ display: react }} placeholder='Relevant Clients (React)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.react_client} />
                                                    <input type="text" className='my-1 mx-1' name="react_link" id="react_link" style={{ display: react }} placeholder='Relevant Links (React)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.react_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="frontend_service" value='Angular' id='angular_frontend' onChange={handleShowHideANGULARFRONTEND} />
                                                    <label htmlFor="angular_frontend" style={{ color: "black", fontWeight: "400" }}>Angular </label>
                                                    <input type="text" className='my-1 mx-1' name="angular_frontend_client" id="angular_frontend_client" style={{ display: angularFrontEnd }} placeholder='Relevant Clients (Angular)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.angular_frontend_client} />
                                                    <input type="text" className='my-1 mx-1' name="angular_frontend_link" id="angular_frontend_link" style={{ display: angularFrontEnd }} placeholder='Relevant Links (Angular)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.angular_frontend_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="frontend_service" value='View Js' id='view_js' onChange={handleShowHideVIEWJS} />
                                                    <label htmlFor="view_js" style={{ color: "black", fontWeight: "400" }}>View Js </label>
                                                    <input type="text" className='my-1 mx-1' name="view_js_client" id="view_js_client" style={{ display: viewJs }} placeholder='Relevant Clients (View Js)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.view_js_client} />
                                                    <input type="text" className='my-1 mx-1' name="view_js_link" id="view_js_link" style={{ display: viewJs }} placeholder='Relevant Links (View Js)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.view_js_link} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>CMS Development<span></span></label>
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="cms_service" value='Wordpress' id="wordpress" onChange={handleShowHideWORDPRESS} />
                                                    <label htmlFor="wordpress" style={{ color: "black", fontWeight: "400" }}>Wordpress </label>
                                                    <input type="text" className='my-1 mx-1' name="wordpress_client" id="wordpress_client" style={{ display: wordpress }} placeholder='Relevant Clients (Wordpress)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.wordpress_client} />
                                                    <input type="text" className='my-1 mx-1' name="wordpress_link" id="wordpress_link" style={{ display: wordpress }} placeholder='Relevant Links (Wordpress)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.wordpress_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" id="shopify" name="cms_service" value='Shopify' onChange={handleShowHideSHOPIFY} />
                                                    <label htmlFor="shopify" style={{ color: "black", fontWeight: "400" }}>Shopify </label>
                                                    <input type="text" className='my-1 mx-1' name="shopify_client" id="shopify_client" style={{ display: shopify }} placeholder='Relevant Clients (Shopify)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.shopify_client} />
                                                    <input type="text" className='my-1 mx-1' name="shopify_link" id="shopify_link" style={{ display: shopify }} placeholder='Relevant Links (Shopify)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.shopify_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="cms_service" value='Open Cart' id='open_cart' onChange={handleShowHideOPENCART} />
                                                    <label htmlFor="open_cart" style={{ color: "black", fontWeight: "400" }}>Open Cart </label>
                                                    <input type="text" className='my-1 mx-1' name="open_cart_client" id="open_cart_client" style={{ display: openCart }} placeholder='Relevant Clients (Open Cart)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.open_cart_client} />
                                                    <input type="text" className='my-1 mx-1' name="open_cart_link" id="open_cart_link" style={{ display: openCart }} placeholder='Relevant Links (Open Cart)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.open_cart_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="cms_service" value='Drupal' id='drupal' onChange={handleShowHideDRUPAL} />
                                                    <label htmlFor="drupal" style={{ color: "black", fontWeight: "400" }}>Drupal </label>
                                                    <input type="text" className='my-1 mx-1' name="drupal_client" id="drupal_client" style={{ display: drupal }} placeholder='Relevant Clients (Drupal)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.drupal_client} />
                                                    <input type="text" className='my-1 mx-1' name="drupal_link" id="drupal_link" style={{ display: drupal }} placeholder='Relevant Links (Drupal)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.drupal_link} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label>Others<span></span></label>
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="others" value='Gaming' id="gaming" onChange={handleShowHideGAMING} />
                                                    <label htmlFor="gaming" style={{ color: "black", fontWeight: "400" }}>Gaming </label>
                                                    <input type="text" className='my-1 mx-1' name="gaming_client" id="gaming_client" style={{ display: gaming }} placeholder='Relevant Clients (Gaming)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.gaming_client} />
                                                    <input type="text" className='my-1 mx-1' name="gaming_link" id="gaming_link" style={{ display: gaming }} placeholder='Relevant Links (Gaming)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.gaming_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" id="blockchain" name="others" value='Blockchain' onChange={handleShowHideBLOCKCHAIN} />
                                                    <label htmlFor="blockchain" style={{ color: "black", fontWeight: "400" }}>Blockchain </label>
                                                    <input type="text" className='my-1 mx-1' name="blockchain_client" id="blockchain_client" style={{ display: blockchain }} placeholder='Relevant Clients (Blockchain)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.blockchain_client} />
                                                    <input type="text" className='my-1 mx-1' name="blockchain_link" id="blockchain_link" style={{ display: blockchain }} placeholder='Relevant Links (Blockchain)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.blockchain_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="others" value='Artificial Intelligence' id='ai' onChange={handleShowHideAI} />
                                                    <label htmlFor="ai" style={{ color: "black", fontWeight: "400" }}>Artificial Intelligence </label>
                                                    <input type="text" className='my-1 mx-1' name="ai_client" id="ai_client" style={{ display: ai }} placeholder='Relevant Clients (Artificial Intelligence)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.ai_client} />
                                                    <input type="text" className='my-1 mx-1' name="ai_link" id="ai_link" style={{ display: ai }} placeholder='Relevant Links (Artificial Intelligence)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.ai_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="others" value='Machine Learning' id='ml' onChange={handleShowHideML} />
                                                    <label htmlFor="ml" style={{ color: "black", fontWeight: "400" }}>Machine Learning </label>
                                                    <input type="text" className='my-1 mx-1' name="ml_client" id="ml_client" style={{ display: ml }} placeholder='Relevant Clients (Machine Learning)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.ml_client} />
                                                    <input type="text" className='my-1 mx-1' name="ml_link" id="ml_link" style={{ display: ml }} placeholder='Relevant Links (Machine Learning)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.ml_link} />
                                                    <br />
                                                    <input className="mr-2" style={{ width: "auto" }} type="checkbox" name="others" value='Metaverse' id='metaverse' onChange={handleShowHideMETAVERSE} />
                                                    <label htmlFor="metaverse" style={{ color: "black", fontWeight: "400" }}>Metaverse </label>
                                                    <input type="text" className='my-1 mx-1' name="metaverse_client" id="metaverse_client" style={{ display: metaverse }} placeholder='Relevant Clients (Metaverse)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.metaverse_client} />
                                                    <input type="text" className='my-1 mx-1' name="metaverse_link" id="metaverse_link" style={{ display: metaverse }} placeholder='Relevant Links (Metaverse)'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.metaverse_link} />
                                                </div>
                                            </div>
                                            <input type="button" name="previous" className="previous action-button" value="&larr; Previous" onClick={() => { navigate('/it-service-provider-individual-bank-details') }} />
                                            <input type="submit" name="submit" className="submit action-button" value="Submit" />
                                        </fieldset>


                                    </form>
                                </div>
                            </div>
                            {/* ===============Company Tab Area End=============== */}
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </>
    )


}

export default ITServiceProviderIndividualService1